var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_244",
    "data-name": "Group 244",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 34,
    height: 34,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(6 11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M20.148,12.668H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0H20.148a.5.5,0,0,1,.5.5V12.168a.5.5,0,0,1-.5.5M1,11.668H19.648V1H1Z",
    fill: "#4eaaf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M4.325,9.459a.5.5,0,0,1-.5-.5V3.709a.5.5,0,1,1,1,0v5.25a.5.5,0,0,1-.5.5",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M8.325,9.459a.5.5,0,0,1-.5-.5V3.709a.5.5,0,1,1,1,0v5.25a.5.5,0,0,1-.5.5",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M12.325,9.459a.5.5,0,0,1-.5-.5V3.709a.5.5,0,1,1,1,0v5.25a.5.5,0,0,1-.5.5",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M16.325,9.459a.5.5,0,0,1-.5-.5V3.709a.5.5,0,0,1,1,0v5.25a.5.5,0,0,1-.5.5",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M21.08,10.263h-.625a.491.491,0,0,1,0-.982h.625a.494.494,0,0,0,.509-.474V3.862a.494.494,0,0,0-.509-.474h-.625a.491.491,0,0,1,0-.982h.625a1.475,1.475,0,0,1,1.491,1.456V8.807a1.475,1.475,0,0,1-1.491,1.456",
    fill: "#4eaaf6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.03d5e547e413ffd463a33a47cdd26df2.svg";
export { ForwardRef as ReactComponent };